import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { Command, CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { VacantRentalObjectService } from './../data/vacant-period.service';
import { rentalObjectFormCommand, vacantRentalObjectCommand } from '../../model/const/command';
import { MessageService } from '../../../core/service/message.service';
import { VacantRentalObject } from '../../model/vacant-rental-object';

@Injectable()
export class CreateBlockContractRentalObjectCommandHandler implements ICommandHandler {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    private _navigation: NavigationService,
    private _messageService: MessageService,
    private _service: VacantRentalObjectService
  ) {}

  canExecute(command: CommandBase): boolean {
    return (
      command instanceof MultiselectCommand && command.id === vacantRentalObjectCommand.createBlockContract && command.items.length > 0
    );
  }

  execute(command: CommandBase): Observable<void> {
    let items = (command as MultiselectCommand).items.map(val => val as VacantRentalObject);
    if (!items.every((val, i, arr) => val.property === arr[0].property)) {
      return of(this._messageService.showWarning('VACANT_RENTAL_OBJECT_LIST.OBJECTS_PROPERTY_DIFFERS'));
    }
    return from(
      this._navigation.navigate(['block', 'contracts', 'add']).then(result => {
        if (result) {
          this._messageDispather.send(items);
        }
      })
    );
  }
}
